
export function normalizePiva(piva: string) {
    return piva.replace(/\s/g, "");
}

export function validatePiva(piva: string) {
    piva = normalizePiva(piva);
    if (piva.length === 0)
        return false
    else if (piva.length !== 11)
        return false
    if (! /^[0-9]{11}$/.test(piva))
        return false
    var s = 0;
    for (var i = 0; i < 11; i++) {
        var n = piva.charCodeAt(i) - "0".charCodeAt(0);
        if ((i & 1) === 1) {
            n *= 2;
            if (n > 9)
                n -= 9;
        }
        s += n;
    }
    if (s % 10 !== 0) return false
    return true;
}